import { jsxs as d, jsx as l } from "react/jsx-runtime";
const i = (e) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...e,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "#4285F4",
          fillRule: "evenodd",
          d: "M20.64 12.205q-.002-.958-.164-1.841H12v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.874 2.684-6.615",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "#34A853",
          fillRule: "evenodd",
          d: "M12 21c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H3.957v2.332A9 9 0 0 0 12 21",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "#FBBC05",
          fillRule: "evenodd",
          d: "M6.964 13.71A5.4 5.4 0 0 1 6.682 12c0-.593.102-1.17.282-1.71V7.958H3.957A9 9 0 0 0 3 12c0 1.452.348 2.827.957 4.042z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "#EA4335",
          fillRule: "evenodd",
          d: "M12 6.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C16.462 3.891 14.426 3 12 3a9 9 0 0 0-8.043 4.958l3.007 2.332C7.672 8.163 9.656 6.58 12 6.58",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
export {
  i as default
};
